import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VForm,[_c(VCard,[_c(VCardTitle,[_vm._v("Whatsapp Gateway")]),(_vm.qr != null)?_c(VCardSubtitle,[_vm._v(" Silahkan scan QRCode berikut ")]):_vm._e(),_c(VCardText,[_c(VRow,{staticStyle:{"min-height":"200px"},attrs:{"align":"center","justify":"center"}},[(_vm.qr != null)?[_c('div',{staticClass:"pa-5"},[_c('img',{staticStyle:{"width":"400px","max-width":"100%"},attrs:{"src":_vm.qr,"alt":""}})])]:(_vm.isConnected)?[_c('div',[_vm._v("Whatsapp sudah terhubung.")])]:[_c('div',[_vm._v("Memuat...")])]],2)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }